<ng-container *ngrxLet="jwtLog$ as jwtLog">
    <div class="log-cinematic-sub-section-jwt__column-group">
       <!-- 1st column -->
       <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.jwtVerifiedLabel | vtranslate }}
            </div>
            <div
                *ngIf="jwtLog.is_jwt_verified !== undefined; else na"
                logFilter
                property="jwt_log.is_jwt_verified"
                [value]="jwtLog.is_jwt_verified"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ jwtLog.is_jwt_verified }}
            </div>

            <div logFieldTitle>{{ l10nKeys.tokenPayloadLabel | vtranslate }}</div>
            <div
                *ngIf="jwtLog.token_payload as tokenPayload; else na"
                logFilter
                property="jwt_log.token_payload"
                [value]="tokenPayload"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ tokenPayload }}
            </div>
        </div>

        <!-- 2nd column -->
        <div logCinematicSectionColumn>
            <h5 class="log-cinematic-section__column-title">
                {{ globalL10nKeys.authorizationLabel | vtranslate }}
            </h5>
            <div logFieldTitle>
                {{ globalL10nKeys.ruleNameLabel | vtranslate }}
            </div>
            <div
                *ngIf="jwtLog.authz_rule_match?.rule_name as ruleName; else na"
                logFilter
                property="jwt_log.authz_rule_match.rule_name"
                [value]="ruleName"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ ruleName }}
            </div>

            <div logFieldTitle>{{ globalL10nKeys.actionLabel | vtranslate }}</div>
            <div
                *ngIf="jwtLog.authz_rule_match?.rule_action as action; else na"
                logFilter
                property="jwt_log.authz_rule_match.rule_action"
                [value]="action"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ action }}
            </div>
        </div>

        <!-- 3rd column -->
        <div logCinematicSectionColumn>
            <h5 class="log-cinematic-section__column-title">
                {{ globalL10nKeys.authenticationLabel | vtranslate }}
            </h5>
            <div logFieldTitle>
                {{ globalL10nKeys.ruleNameLabel | vtranslate }}
            </div>
            <div
                *ngIf="jwtLog.authn_rule_match?.rule_name as ruleName; else na"
                logFilter
                property="jwt_log.authn_rule_match.rule_name"
                [value]="ruleName"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ ruleName }}
            </div>

            <div logFieldTitle>{{ globalL10nKeys.actionLabel | vtranslate }}</div>
            <div
                *ngIf="jwtLog.authn_rule_match?.rule_action as action; else na"
                logFilter
                property="jwt_log.authn_rule_match.rule_action"
                [value]="action"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ action }}
            </div>
        </div>
    </div>

</ng-container>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>
